import { createApp } from 'vue'
import App from './App.vue'
import 'ant-design-vue/dist/reset.css';
import Antd from 'ant-design-vue'
import router from './router';
import clickOutside from './directives/clickOutside';

import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'

createApp(App).use(Antd).use(router).directive('click-outside', clickOutside).mount('#app')
